namespace SolovisGateway.Admin.Organizations {

    export interface OrgRemoveDomainFromLiveConnectionDialogOptions {
        domain: string;
        isLastDomain?: boolean;
        onRemove?: () => void;
        onCancel?: () => void;
    }

    export class OrgRemoveDomainFromLiveConnectionDialog {

        private _options: OrgRemoveDomainFromLiveConnectionDialogOptions;

        private _dialog: any;
        private _confirmContainer: JQuery;
        private _loaderContainer: JQuery;

        constructor(options: OrgRemoveDomainFromLiveConnectionDialogOptions) {
            this._options = options;
        }

        public show() {
            var body = $("<div>").css({ "padding": "0 15px" });

            var confirmContainer = $("<div>");
            body.append(confirmContainer);
            this._confirmContainer = confirmContainer;

            confirmContainer.append($("<p>").append(
                $("<strong>").text(this._options.domain),
                $("<span>").text(" will stop federating to your identity provider as soon as it is removed.")
            ));

            confirmContainer.append($("<p>").text(
                "Users on this domain will sign in with a username and password instead of SSO."
            ));

            confirmContainer.append($("<p>").text(
                "Their access, roles, and environments do not change. Only the way they sign in changes. The connection's other email domains are not affected and stay live."
            ));

            if (this._options.isLastDomain) {
                var lastDomainWarning = $("<div>").css({
                    "background-color": "#fcf8e3",
                    "border": "1px solid #faebcc",
                    "color": "#8a6d3b",
                    "padding": "12px 15px",
                    "border-radius": "4px",
                    "margin-bottom": "10px"
                }).text(
                    "This is the only email domain on this connection. Once it is removed, no one will sign in through this connection until you add a domain to it."
                );
                confirmContainer.append(lastDomainWarning);

                confirmContainer.append($("<p>").text("The connection stays Enabled."));
            }

            var loaderContainer = $("<div>")
                .css({ "position": "relative", "height": "150px", "display": "none" });
            Solovis.UI.StockAnimations.createSpinningCircles({
                diameter: "60px",
                top: "50%",
                left: "50%",
                showShadow: true
            }).appendTo(loaderContainer);
            body.append(loaderContainer);
            this._loaderContainer = loaderContainer;

            this._dialog = new (Solovis as any).UI.Dialog({
                container: body,
                title: "Remove " + this._options.domain + " from this connection?",
                modal: true,
                autoOpen: true,
                center: true,
                destroyOnClose: true,
                actions: ["Close"],
                width: 600,
                buttons: this._buildDefaultButtons()
            });
        }

        public resetToConfirm() {
            this._loaderContainer.hide();
            this._confirmContainer.show();
            this._dialog.updateButtons(this._buildDefaultButtons());
        }

        private _buildDefaultButtons() {
            var self = this;
            return [
                {
                    label: "Remove Domain",
                    click: function () {
                        self._attemptRemove();
                    }
                },
                {
                    label: "Cancel",
                    click: function () {
                        self._dialog.close();
                        if (self._options.onCancel) {
                            self._options.onCancel();
                        }
                    }
                }
            ];
        }

        private _attemptRemove() {
            this._confirmContainer.hide();
            this._loaderContainer.show();
            this._dialog.updateButtons([]);

            if (this._options.onRemove) {
                this._options.onRemove();
            }
        }
    }
}
